import React from 'react'
import styled from 'styled-components'
import { Heading, Card, CardBody, useMatchBreakpoints } from 'penguinfinance-uikit2'

const StyledCard = styled(Card)<{ isMobile?: boolean; bgColor?: string }>`
  margin-left: 4px;
  margin-right: 4px;
  position: relative;
  width: auto;
  background: ${({ bgColor }) => bgColor || '#EE3E40'};
  border-radius: 10px;
  box-shadow: none;
  min-width: 100px;

  @media (min-width: 640px) {
    min-width: 140px;
    margin-left: 10px;
    margin-right: 10px;
  }
  @media (min-width: 768px) {
    min-width: 200px;
    margin-left: 10px;
    margin-right: 10px;
  }
  @media (min-width: 968px) {
    min-width: 140px;
    margin-left: 10px;
    margin-right: 10px;
  }
  @media (min-width: 1200px) {
    min-width: 200px;
  }
`
const StyledCardBody = styled(CardBody)`
  padding: 28px 8px 16px;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 160px;

  @media (min-width: 768px) {
    min-height: 220px;
  }
  @media (min-width: 968px) {
    min-height: 220px;
  }
  @media (min-width: 1200px) {
    padding: 48px 24px 32px;
    min-height: 256px;
  }
`

const CardMidContent = styled(Heading).attrs({ size: 'xl' })`
  font-size: 18px;
  line-height: 24px;
  color: #ffffff;
  font-family: 'GothamBlack Font';
  font-weight: 200;

  @media (min-width: 640px) {
    line-height: 36px;
    font-size: 28px;
  }
  @media (min-width: 768px) {
    line-height: 40px;
    font-size: 36px;
  }
  @media (min-width: 968px) {
    line-height: 36px;
    font-size: 28px;
  }
  @media (min-width: 1200px) {
    line-height: 40px;
    font-size: 36px;
  }
`

const CardInfoMidContent = styled(Heading).attrs({ size: 'xl' })`
  font-size: 13px;
  line-height: 21px;
  color: #ffffff;
  font-family: Kanit;
  font-weight: 300;
  font-style: normal;

  @media (min-width: 640px) {
    font-size: 20px;
    line-height: 32px;
  }
  @media (min-width: 768px) {
    line-height: 48px;
    font-size: 24px;
  }
  @media (min-width: 968px) {
    line-height: 32px;
    font-size: 20px;
  }
  @media (min-width: 1200px) {
    line-height: 48px;
    font-size: 24px;
  }
`

const Text = styled(Heading)<{ isMobile?: boolean }>`
  color: #ffffff;
  font-weight: 300;
  font-size: 12px;
  font-family: 'Telegraf UltraBold Font';

  @media (min-width: 640px) {
    font-size: 18px;
  }

  @media (min-width: 1200px) {
    font-size: 20px;
    line-height: 24px;
  }
`

const StyledTitleText = styled(Text)<{ subTitle?: string }>`
  font-size: 14px;
  font-family: Kanit;
  font-style: normal;
  font-weight: bold;
  margin-bottom: 12px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (min-width: 640px) {
    font-size: 20px;
    margin-bottom: 18px;
  }

  @media (min-width: 768px) {
    font-size: 24px;
    margin-bottom: 24px;
    max-width: 140px;
    height: 24px;
  }
  @media (min-width: 968px) {
    font-size: 20px;
    margin-bottom: 18px;
    max-width: 140px;
    height: 24px;
  }
  @media (min-width: 1200px) {
    font-size: 28px;
    margin-bottom: ${({ subTitle })=> subTitle ? '24px' : '28px'};
    max-width: 150px;
    line-height: 28px;
    height: 24px;
  }
`

const InfoCard = (props) => {
  const { isXl } = useMatchBreakpoints()
  const isMobile = !isXl
  const { title, subTitle, value, unit, bgColor } = props
  return (
    <StyledCard bgColor={bgColor} isMobile={isMobile}>
      <StyledCardBody>
        <StyledTitleText isMobile={isMobile} subTitle={subTitle}>{title}</StyledTitleText>
        <CardInfoMidContent>{subTitle}</CardInfoMidContent>
        <CardMidContent>{value}</CardMidContent>
        <CardInfoMidContent mt='-8px'>{unit}</CardInfoMidContent>
      </StyledCardBody>
    </StyledCard>
  )
}

export default InfoCard
